export function updateCurrentProduct(state, { product }) {
  // Current product should never be observed
  state.current = JSON.parse(JSON.stringify(product));
}

export function flushCurrentProduct(state) {
  state.current = null;
}

export function flush(state) {
  state.current = null;
}
